// extracted by mini-css-extract-plugin
export default {"loadingRoot":"Loading_loadingRoot__13jSU","spin":"Loading_spin__pxWmT"};